export const cssStyles = `
/* ==========================================
   1. BODY AND PAGE BASE
   ========================================== */
.contract-body {
  width: 100%;
  font-family: Arial, sans-serif;
  color: #000;
  font-size: 13px;
  line-height: 1.4;
}

.contract-body p {
  margin: 0;
  padding: 0;
}

/* Prevent thead from repeating when table breaks across pages */
.contract-body thead {
  display: table-row-group;
}

.contract-main-title {
  text-align: center;
  font-weight: bold;
  font-size: 15px;
  margin-top: 5px;
  text-transform: uppercase;
}

/* ==========================================
   2. HEADER (Logo and reference number box)
   ========================================== */
.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.contract-header-table {
  width: 270px;
  border-collapse: collapse;
}

.contract-refno-cell {
  padding: 6px 15px;
  border: 1px solid black;
}

.contract-refno-cell p {
  text-align: left;
  font-size: 13px;
  white-space: nowrap;
}

/* ==========================================
   3. TABLE STRUCTURE AND CELLS
   ========================================== */
.contract-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.contract-table-header-row th {
  border: 1px solid black;
  text-align: center;
  padding: 5px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}

.contract-sub-header {
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: none;
  border-bottom: none;
  text-align: left;
  padding: 4px 6px;
  font-size: 11px;
  vertical-align: top;
  font-weight: normal;
}

.contract-sub-header:nth-child(2),
.contract-sub-header:nth-child(3) {
  text-align: center;
}

.contract-label-cell {
  border: 1px solid black;
  padding: 5px 8px;
  vertical-align: middle;
  font-size: 12px;
}

.contract-value-cell {
  border: 1px solid black;
  padding: 5px 8px;
  vertical-align: middle;
  font-size: 11px;
}

/* ==========================================
   4. LARGE TEXT BLOCKS (Initial Hire (A)/(B) sections)
   ========================================== */
.contract-text-block {
  font-size: 11px;
  line-height: 1.45;
  padding: 12px 15px;
}

.text-justify {
  text-align: justify;
  text-justify: inter-word;
}

.text-bold {
  font-weight: bold;
}

.text-italic {
  font-style: italic;
}

/* ==========================================
   5. PRICE ALIGNMENT (currency symbol left, amount right)
   ========================================== */

   
.contract-price-cell {
  text-align: right;
}

.contract-price-cell span:first-child {
  float: left;
}

.contract-price-cell span:last-child {
  float: right;
}

/* ==========================================
   6. SPACING, COLUMN WIDTHS, PAGE CONTROL
   ========================================== */
.margin-top-large {
  margin-top: 30px;
}

.margin-top-medium {
  margin-top: 20px;
}

.margin-top-small {
  margin-top: 10px;
}
.margin-top-tiny {
  margin-top: 5px;
}
.contract-terms-td {
  vertical-align: top !important;
  padding-top: 6px;
  font-size: 11px;
  line-height: 1.4;
}

.contract-half-space {
  width: 40%;
}

.contract-third-space {
  width: 30%;
}

.contract-quarter-space {
  width: 20%;
}

/* Prevents a table row from splitting across two PDF pages */
.contract-no-break {
  page-break-inside: avoid !important;
}

/* Forces a new PDF page */
.page-break {
  page-break-after: always;
}

/* ==========================================
   7. KEY INFORMATION SECTION
   ========================================== */
.contract-key-info-cell {
  border: 1px solid black;
  padding: 5px 8px;
  vertical-align: top;
  font-size: 11px;
  line-height: 1.4;
}

.contract-key-info-list {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.contract-key-info-list td {
  border: none !important;
  padding: 1px 0;
  font-size: 11px;
  vertical-align: top;
}

.contract-bullet-cell {
  width: 18px;
  padding-left: 10px !important;
  padding-right: 4px !important;
}

/* ==========================================
   8. SIGNATURE BLOCKS
   ========================================== */
.contract-signature-cell {
  border: none;
  padding: 4px 8px;
  font-size: 11px;
  line-height: 1.4;
  vertical-align: top;
}

/* ==========================================
   9. PAGE 3 — OTHER INFORMATION
   ========================================== */

/* Bold label above each section table */
.contract-section-label {
  font-weight: bold;
  font-size: 12px;
  margin-top: 12px;
  margin-bottom: 3px;
}

/* Cell used in owner/hirer/dealer/delivery info tables */
.contract-info-cell {
  border: 1px solid black;
  padding: 4px 6px;
  vertical-align: top;
  font-size: 11px;
  line-height: 1.6;
}

/* Column header in Additional services / Insurance tables */
.contract-col-header {
  border: 1px solid black;
  padding: 4px 6px;
  text-align: left;
  font-size: 11px;
  font-weight: normal;
  vertical-align: top;
}

/* Checkbox characters alignment */
.contract-checkbox-cell {
  border: 1px solid black;
  padding: 4px 6px;
  vertical-align: top;
  font-size: 11px;
  line-height: 1.6;
}

/* ==========================================
   10. PRE-CONTRACT SPECIFIC
   ========================================== */

/* Compact font for Additional Information table (page 3) */
.precontract-additional-table td,
.precontract-additional-table th {
  font-size: 11px !important;
  line-height: 1.30 !important;
}

/* "Pre-contract Information" centered title above main title */
.precontract-doc-title {
  text-align: center;
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 2px;
}

/* Bold heading for Additional Information page and Right to Cancel sections */
.precontract-section-heading {
  font-weight: bold;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 4px;
}

/* Italic subtitle under the Additional Information heading */
.precontract-section-subtitle {
  font-size: 11px;
  font-style: italic;
  margin-bottom: 8px;
}

/* Body text paragraphs on Right to Cancel page */
.precontract-plain-text {
  font-size: 11px;
  line-height: 1.45;
  text-align: justify;
  text-justify: inter-word;
  margin-bottom: 6px;
}

/* Indented block (contact details, address) */
.precontract-indented {
  margin-left: 20px;
}

/* Model Cancellation Form field lines */
.precontract-form-line {
  font-size: 11px;
  line-height: 1.8;
  border-bottom: 1px solid black;
  margin-bottom: 6px;
  padding-bottom: 2px;
}

/* Styled checkbox box mimicking the PDF checkbox appearance */
.pdf-checkbox {
  display: inline-block;
  width: 11px;
  height: 11px;
  border: 1px solid black;
  text-align: center;
  line-height: 10px;
  font-size: 9px;
  font-weight: bold;
  vertical-align: middle;
  margin-right: 4px;
}
`;
